import React, { useMemo } from 'react';

const formatDuration = (seconds) => {
  const safe = Math.max(0, Math.floor(Number(seconds) || 0));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const secs = safe % 60;

  return [hours, minutes, secs].map((value) => String(value).padStart(2, '0')).join(':');
};

const DailyCountdown = ({ secondsUntilRollover, labelPrefix = 'Next daily word in' }) => {
  const label = useMemo(
    () => formatDuration(secondsUntilRollover),
    [secondsUntilRollover],
  );

  return (
    <div className="daily-countdown" role="status" aria-live="polite">
      <strong>
        {labelPrefix} {label}
      </strong>
    </div>
  );
};

export default DailyCountdown;

